import AppConfig from "util/AppConfig";
import { PSEUDO_LANGUAGE } from "util/pseudoLocalize";
export const DEFAULT_LANGUAGE = "en";
export const LANGUAGES = [
  { code: "en", name: "English", beta: false },
  { code: "de", name: "Deutsch", beta: true },
  { code: "es", name: "Espa\xF1ol", beta: true },
  { code: "fr", name: "Fran\xE7ais", beta: true },
  { code: "it", name: "Italiano", beta: true },
  { code: "pl", name: "Polski", beta: true },
  { code: "pt-BR", name: "Portugu\xEAs (Brasil)", beta: true },
  { code: "zh-CN", name: "\u7B80\u4F53\u4E2D\u6587", beta: true },
  { code: "zh-TW", name: "\u7E41\u9AD4\u4E2D\u6587", beta: true },
  { code: "ja", name: "\u65E5\u672C\u8A9E", beta: true },
  { code: PSEUDO_LANGUAGE, name: "Pseudo", beta: false, developmentOnly: true }
];
export const availableLanguages = () => LANGUAGES.filter(({ developmentOnly }) => !developmentOnly || AppConfig.gl2DevMode());
export const getLanguage = (code) => {
  var _a;
  return (_a = LANGUAGES.find((language) => language.code === code)) != null ? _a : LANGUAGES[0];
};
